import { onSettle } from '@bugsnag/browser-performance';
import pathToRegexp from 'path-to-regexp';

function flattenRoutes(routes, _prefix = '') {
    const prefix = `${!_prefix || _prefix === '/' ? _prefix : `${_prefix}/`}`;
    return [
        ...routes.map(route => `${prefix}${route.path || ''}`),
        ...routes.reduce((accum, route) => [...accum, ...(route.children ? flattenRoutes(route.children, `${prefix}${route.path}`) : [])], [])
    ];
}
class VueRouterRoutingProvider {
    constructor(router, basename) {
        this.router = router;
        const normalizedBasename = !basename || basename === '/' ? '' : basename;
        function resolveRoute(url) {
            return flattenRoutes(router.getRoutes()).find((fullRoutePath) => url.pathname.replace(normalizedBasename !== null && normalizedBasename !== void 0 ? normalizedBasename : '', '').match(pathToRegexp(fullRoutePath))) || 'no-route-found';
        }
        this.resolveRoute = resolveRoute;
    }
    listenForRouteChanges(startRouteChangeSpan) {
        this.router.beforeResolve((to, from) => {
            if (!from.name) {
                // initial load
                return;
            }
            const absoluteURL = new URL(to.path, document.baseURI);
            const span = startRouteChangeSpan(absoluteURL, 'beforeResolve');
            onSettle((endTime) => {
                span.end(endTime);
            });
        });
    }
}

export { VueRouterRoutingProvider };
